export default {
    glossaryURL: `${process.env.REACT_APP_EDITION_DATA_URL}/glossary.json`,
    glossary: {},
    loaded: false
}	